<div class="page-content">

  <one-breadcrumbs>

    <one-breadcrumb-element *ngFor="let breadcrumb of breadcrumbs; last as isLast; first as isFirst; even as isEven; odd as isOdd">

      <span *ngIf="isFirst" class="mat-caption" routerLinkActive="router-link-active" (click)="gotoNotificationPage()">
        {{ breadcrumb.label }}
      </span>

      <span *ngIf="isOdd && !isFirst && !isLast && !isEven" class="mat-caption" routerLinkActive="router-link-active" (click)="gotoNotificationDetailsPage()">
        {{ breadcrumb.label }}
      </span>

      <span *ngIf="isEven && !isFirst && !isLast && !isOdd" class="mat-caption" routerLinkActive="router-link-active" (click)="gotoAccountDetailsPage()">
        {{ breadcrumb.label }}
      </span>

      <span *ngIf="isLast" class="mat-small">
        {{ breadcrumb.label }}
      </span>

      <mat-icon>arrow_forward</mat-icon>
      
    </one-breadcrumb-element>
  </one-breadcrumbs>

  <div class="contact-detail-container">

    <p class="cd-header">{{ customerTitle }}</p>

    <div class="cd-card-container">

      <mat-card oneCard class="cd-card-list cd-onecard" style="margin-right: 12px;">

        <mat-card-title class="cd-mat-card">
          <div class="cd-card-title">Recipient</div>
        </mat-card-title>

        <mat-card-content style="display: block;">
          <form [formGroup]="recepientForm">

            <div class="cd-item">

              <div class="cd-title">Source</div>

              <div *ngIf="!showEditControls" class="cd-chip-value">
                <mat-chip class="customer-details-source-chip truncate-text" oneChip oneChipAppearance="outline" *ngIf="customerData.DataSource && customerData.DataSource.length > 0" [title]="customerData.DataSource">
                  {{ customerData.DataSource }}
                </mat-chip>
              </div>

              <div *ngIf="showEditControls">
                <input formControlName="recepientSource" class="cd-edit-value" />
                <mat-error *ngIf="recepientForm.controls['recepientSource'].invalid" style="margin-top: 5px;">
                  Source name must be at least 2 characters and should not contain any special character
                </mat-error>
              </div>

            </div>

            <div class="cd-item">

              <div class="cd-title">Contact name</div>

              <div *ngIf="!showEditControls" class="cd-value truncate-text" [title]="customerData.CustomerContactName">
                {{ customerData.CustomerContactName }}
              </div>

              <div *ngIf="showEditControls">
                <input formControlName="recepientName" class="cd-edit-value" />
                <mat-error *ngIf="recepientForm.controls['recepientName'].invalid" style="margin-top: 5px;">
                  Contact name must be at least 2 characters and should not contain any numeric or special character
                </mat-error>
              </div>

            </div>

            <div class="cd-item">

              <div class="cd-title">Contact email</div>

              <div *ngIf="!showEditControls" class="cd-value truncate-text" [title]="customerData.CustomerContactEmail">
                {{ customerData.CustomerContactEmail }}
              </div>

              <div *ngIf="showEditControls">
                <input formControlName="recepientEmail" [ngClass]="{ disabled: !isResendEnabled }" class="cd-edit-value" />
                <mat-error *ngIf="recepientForm.controls['recepientEmail'].invalid" style="margin-top: 5px;">
                  Email must be in in proper email format (i.e abc&#64;abc.com)
                </mat-error>
              </div>

            </div>

            <div class="cd-item">

              <div class="cd-title">Account name</div>

              <div class="cd-value truncate-text" [title]="customerData.CustomerName">
                {{ customerData.CustomerName }}
              </div>

            </div>

          </form>
        </mat-card-content>
        
      <div>
        
        <mat-card-actions *ngIf="!userPermission.SendNotification" class="cd-feedback-list-actionbutton cd-feedback-list-Editbutton" style="margin-top: 8.5%">
          <button mat-stroked-button one-secondary-button (click)="viewAuditTrail()">Audit trail</button>
        </mat-card-actions>

        <mat-card-actions *ngIf="!showEditControls && userPermission.SendNotification" class="cd-feedback-list-actionbutton cd-feedback-list-Editbutton" style="margin-top: 8.5%">
          <button mat-stroked-button one-secondary-button (click)="viewAuditTrail()">Audit trail</button>
          <button one-secondary-button mat-stroked-button [disabled]="isEditDisabled || isSetCom || isNotiStat" (click)="openEditForm()">Edit</button>
        </mat-card-actions>

        <mat-card-actions *ngIf="showEditControls && userPermission.SendNotification" class="cd-feedback-list-actionbutton cd-feedback-list-Editbutton" style="margin-top: 8.5%">
          <button one-secondary-button mat-stroked-button class="cd-close" (click)="closeEditForm()">Cancel</button>
          <button color="primary" mat-flat-button [disabled]="recepientForm.invalid" (click)="editRecepientDetails()">Save</button>
        </mat-card-actions>
      
      </div>

      </mat-card>

      <mat-card oneCard class="cd-card-list cd-onecard" style="margin-left: 12px;">

        <mat-card-title style="margin-bottom: 0px;">

          <div class="cd-card-title">Communication</div>

          <div class="cd-chip-status">
            <mat-chip class="customer-details-source-chip truncate-text" oneChip oneChipAppearance="outline" [title]="customerData.Status"> {{ displayStatus(customerData.Status) }}</mat-chip>
          </div>

        </mat-card-title>

        <mat-card-content style="display: block;">

          <div class="cd-item">

            <div class="cd-title">Date sent</div>

            <div class="cd-value" [title]="appUtils.formatDateWithTime(customerData.DateSent)">
              {{ appUtils.formatDateWithTime(customerData.DateSent) }}
            </div>

          </div>

          <div class="cd-item">

            <div class="cd-title">Date delivered</div>

            <div class="cd-value" [title]="appUtils.formatDateWithTime(customerData.DateDelivered)">
              {{ appUtils.formatDateWithTime(customerData.DateDelivered) }}
            </div>

          </div>

          <div class="cd-item">

            <div class="cd-title">Date read</div>

            <div class="cd-value" [title]="appUtils.formatDateWithTime(customerData.DateRead)">
              {{ appUtils.formatDateWithTime(customerData.DateRead) }}
            </div>

          </div>

          <div class="cd-item">

            <div class="cd-title">Feedback received</div>

            <div class="cd-value" [title]="appUtils.formatDateWithTime(customerData.FeedbackReceived)">
              {{ appUtils.formatDateWithTime(customerData.FeedbackReceived) }}
            </div>
          
          </div>

          <div class="cd-item">

            <div class="cd-title">Resend Date</div>

            <div class="cd-value" [title]="appUtils.formatDateWithTime(customerData.ResendDate)">
              {{ appUtils.formatDateWithTime(customerData.ResendDate) }}
            </div>

          </div>

        </mat-card-content>

        <div class="cd-feedback-list-actionbutton">

          <button [disabled]="isSetCom || isNotiStat" *ngIf="customerNotificationData.NotificationReminders && customerNotificationData.NotificationReminders.length > 0" one-secondary-button mat-stroked-button class="btn-mr" title="View reminders" (click)="viewReminders()">View reminders</button>
        
          <button [disabled]="isSetCom || isNotiStat" *ngIf="userPermission.SendNotification && isResendEnabled" mat-flat-button one-secondary-button mat-stroked-button title="Resend notification" (click)="onResendNotification()" style="margin-right: 12px">Resend notification</button>
        
        </div>

      </mat-card>

    </div>

    <div>

      <!-- Acknowledgement -->
      <div [hidden]="(accDataObj.AccountStatus === 'Feedback Received' && accDataObj.AccountSubmitter !== customerData.CustomerContactEmail && accDataObj.AccountSubmitter !== undefined) || !customerData.FeedbackEnabled">
        <mat-card oneCard class="cd-card-customer">

          <mat-card-title class="cd-mat-card">
            <div class="cd-feedback-title">LSO Acknowledgement</div>
          </mat-card-title>

          <mat-card-content>
            <div class="cd-feedback-list">

              <div class="cd-feedback-list-subject" style="margin-top: 0px;">
                Provide acknowledgement on behalf of the contact.
              </div>

              <div *ngIf="ackComment">

                <div class="cd-feedback-list-title">
                  Comments
                </div>

                <div class="cd-feedback-list-subject">
                  {{ackComment}}
                </div>

                <div class="cd-files-list" style="margin-block:10px; width:fit-content;" *ngIf="ackFileName">
                  <div class="single-file">
                    <div class="info" (click)="downloadLSOAttachment(ackFileName, NotificationId, contactNotificationId)" style="display: flex; gap: 10px; margin-right:8rem;">
                      
                      <mat-icon class="one-icons iconcls">{{ appUtils.formatFilesIcons(ackFileName) }}</mat-icon>
                      
                      <div style="display: flex; flex-direction: column; gap: 10px;">
                        <span class="name"> {{ackFileName}} </span>
                        <span class="size"> {{ackFileSize}} </span>
                      </div>

                    </div>
                  </div>
                </div>

              </div>

              <button [disabled]="!userPermission.SendNotification || isEditDisabled || isSetCom || isNotiStat || isDisabled || (accDataObj.AccountStatus === 'Feedback Received' && accDataObj.AccountSubmitter !== customerData.CustomerContactEmail && accDataObj.AccountSubmitter !== undefined)" 
              *ngIf="!ackComment" one-secondary-button mat-stroked-button (click)="lsoAcknowledgement()">
                Acknowledge
              </button>

            </div>
          </mat-card-content>

        </mat-card>
      </div>

      <!-- Email Evidence -->
      <mat-card oneCard class="cd-card-customer">

        <mat-card-title class="cd-mat-card">
          <div class="cd-feedback-title">Email Delivery Evidence</div>
        </mat-card-title>

        <mat-card-content>

          <div *ngFor="let attachment of customerData.EmailEvidenceDocuments">
            <div class="cd-files-list" >
              <div class="single-file">
                <div class="info" (click)="downloadEmailEvidence( attachment.Filename )">
                  
                  <mat-icon class="one-icons iconcls">{{ appUtils.formatFilesIcons('pdf') }}</mat-icon>
                  
                  <div style="margin-left:10px">
                    <p class="name"> {{ attachment.Filename }}.pdf </p>
                    <p class="size" style="display: flex; justify-content: space-between; margin-top: 10px;">
                      <span>{{ attachment.TimeStamp | date:"dd-MMM-yyyy hh:mm a" }}</span>
                      <span> {{ attachment.FileSize }}</span>
                    </p>
                  </div>

                </div>
              </div>
            </div>
          </div>
          
        </mat-card-content>

      </mat-card>

    </div>

  </div>
  
</div>
